import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { h } from 'vue'
import { mdi } from 'vuetify/iconsets/mdi'
import { aliases as mdAliases } from 'vuetify/iconsets/md'

// Material 3 inspired color schemes (can be tuned to brand later)
const md3Light = {
  dark: false,
  colors: {
    // New Year Red: Festive and energetic
    primary: '#D32F2F',
    // Warm Gray: For secondary text and icons
    secondary: '#757575',
    // Gold: For festive accents
    tertiary: '#FFD700',
    // Pure White: Cleanest surface
    surface: '#FFFFFF',
    // Very Light Warm Gray: subtle contrast against white surfaces
    background: '#FAFAFA',
    surfaceVariant: '#F5F5F5',
    outline: '#E0E0E0',
    error: '#B71C1C',
    info: '#D32F2F',
    success: '#2E7D32',
    warning: '#F57C00',
  },
}

const md3Dark = {
  dark: true,
  colors: {
    // Lighter Red for dark mode visibility
    primary: '#EF5350',
    secondary: '#BDBDBD',
    tertiary: '#FFD700',
    // Deep Red-Gray: Modern dark theme background
    surface: '#1A1A1A',
    background: '#121212',
    surfaceVariant: '#2C2C2C',
    outline: '#424242',
    error: '#E57373',
    info: '#EF5350',
    success: '#81C784',
    warning: '#FFB74D',
  },
}

const tapeFuturism = {
  dark: true,
  colors: {
    primary: '#00FFFF',
    secondary: '#FF00FF',
    tertiary: '#FFFF00',
    surface: '#1A1A2E',
    background: '#0F1A2B',
    surfaceVariant: '#23273A',
    outline: '#00FFFF',
    error: '#FF2E63',
    info: '#00B4D8',
    success: '#3CFCC5',
    warning: '#FFC300',
  },
}

// Global component defaults to align with M3
const defaults = {
  VBtn: {
    variant: 'flat', // Flatter, more modern look
    rounded: 'lg', // Slightly rounded, professional
    class: 'text-none font-weight-medium letter-spacing-normal', // Remove uppercase, better weight
    elevation: 0,
  },
  VCard: {
    rounded: 'lg', // Consistent rounded corners
    elevation: 0, // Flat design
    border: true, // Subtle border for definition
    flat: true,
  },
  VTextField: {
    variant: 'outlined',
    density: 'comfortable',
    color: 'primary',
    bgColor: 'surface',
  },
  VSelect: {
    variant: 'outlined',
    density: 'comfortable',
    color: 'primary',
    bgColor: 'surface',
  },
  VAutocomplete: {
    variant: 'outlined',
    density: 'comfortable',
    color: 'primary',
    bgColor: 'surface',
  },
  VTextarea: {
    variant: 'outlined',
    density: 'comfortable',
    color: 'primary',
    bgColor: 'surface',
  },
  VAppBar: {
    flat: true,
    elevation: 0,
    color: 'background', // Blend with background
    density: 'comfortable',
    border: true, // Subtle separator
  },
  VNavigationDrawer: {
    elevation: 0,
    color: 'surface',
    border: 'e', // Right border
  },
  VChip: {
    variant: 'tonal', // Tonal is softer than elevated
    rounded: 'lg',
  },
  VAvatar: {
    variant: 'tonal',
  },
  VDialog: {
    cardProps: {
      elevation: 5, // Popups should have elevation
      rounded: 'xl',
    }
  },
  VMenu: {
    cardProps: {
      elevation: 3,
      rounded: 'lg',
    }
  }
}

export const vuetify = createVuetify({
  icons: {
    // 默认使用 Google Material Symbols Outlined（通过 index.html 引入字体）
    defaultSet: 'ms',
    // 使用 Material 的标准别名集合，覆盖常见的 close/delete 等名称
    aliases: {
      ...mdAliases,
    },
    sets: {
      ms: {
        // Render Material Symbols via font glyphs
        component: (props) => h(
          'span',
          {
            class: 'material-symbols-outlined',
            style: 'font-variation-settings: "FILL" 0, "wght" 400, "opsz" 24',
          },
          props.icon,
        ),
      },
      // Keep MDI available for any legacy/fallback usage
      mdi,
    },
  },
  theme: {
    defaultTheme: 'md3Light',
    themes: {
      md3Light,
      md3Dark,
      tapeFuturism,
    },
  },
  defaults,
})

export default vuetify
